import { Modal, ModalProps } from 'antd';

interface ConfirmDeleteModalProps {
  modalData: ModalProps;
}

export default function ConfirmDeleteModal({ modalData }: ConfirmDeleteModalProps) {
  return (
    <Modal
      {...modalData}
      okButtonProps={{ danger: true }}
      okText="확인"
      cancelText="닫기"
      title="정말 삭제하시겠어요?"
    />
  );
}
